import Model from '../utils/Model'

class PartnerServiceItem {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'PartnerServiceItem'

/**
 * 服务项目
 */
export const PARTNER_BOOKING = new PartnerServiceItem('BOOKING', 'BOOKING', '订舱代理')
export const SHIPPING_COMPANY = new PartnerServiceItem('SHIPPING', 'Shipping company', '船公司')
export const AIRLINE_COMPANY = new PartnerServiceItem('AIRLINE', 'Airline Company', '航空公司')
export const PARTNER_AGENT = new PartnerServiceItem('AGENT', 'AGENT', '海外代理')
export const PARTNER_CUSTOMER = new PartnerServiceItem('CUSTOMER', 'CUSTOMER', '客户')
export const PARTNER_SUPPLY_CHAIN = new PartnerServiceItem('SUPPLY_CHAIN', 'SUPPLY_CHAIN', '供应链线路')
export const PARTNER_CUSTOMS_BROKER = new PartnerServiceItem('CUSTOMS', 'CUSTOMS', '报关')
export const PARTNER_WAREHOUSE = new PartnerServiceItem('WAREHOUSE', 'WAREHOUSE', '仓储')
export const PARTNER_TRUCK = new PartnerServiceItem('TRUCK', 'TRUCK', '运输')
export const PARTNER_OTHER = new PartnerServiceItem('OTHER', 'OTHER', '其它')
export const PARTNER_SETTLEMENT_AGENT = new PartnerServiceItem('SETTLEMENT_AGENT', 'SETTLEMENT_AGENT', '其它')

/**
 * 数据项目
 */
export const PARTNER_SERVICE_ALL = new PartnerServiceItem('ALL', 'ALL', '全部')
export const PARTNER_SERVICE_CUSTOMER = new PartnerServiceItem('CUSTOMER', 'CUSTOMER', '客户')
export const PARTNER_SERVICE_BOOKING_AGENT = new PartnerServiceItem('BOOKING_AGENT', 'BOOKING_AGENT', '订舱代理')
export const PARTNER_SERVICE_OVERSEA_AGENT = new PartnerServiceItem('OVERSEA_AGENT', 'OVERSEA_AGENT', '目的港代理')
export const PARTNER_SERVICE_DESIGNATION_AGENT = new PartnerServiceItem('DESIGNATION_AGENT', 'DESIGNATION_AGENT', '指定货代理')
export const PARTNER_SERVICE_LOCAL = new PartnerServiceItem('LOCAL', 'LOCAL', '本地代理')
export const PARTNER_SERVICE_SETTLEMENT_AGENT = new PartnerServiceItem('SETTLEMENT_AGENT', 'SETTLEMENT_AGENT', '结算代理')
export const PARTNER_SERVICE_SEA_CMP = new PartnerServiceItem('SEA_CMP', 'SEA_CMP', '船公司')
export const PARTNER_SERVICE_AIR_CMP = new PartnerServiceItem('AIR_CMP', 'AIR_CMP', '航空公司')
export const PARTNER_SERVICE_SEA_CMP_AGENT = new PartnerServiceItem('SEA_CMP_AGENT', 'SEA_CMP_AGENT', '船代')
export const PARTNER_SERVICE_CUSTOMS_BROKER = new PartnerServiceItem('CUSTOMS_BROKER', 'CUSTOMS_BROKER', '报关行')
export const PARTNER_SERVICE_TRUCK_CMP = new PartnerServiceItem('TRUCK_CMP', 'TRUCK_CMP', '卡车公司')
export const PARTNER_SERVICE_WAREHOUSE = new PartnerServiceItem('WAREHOUSE', 'WAREHOUSE', '仓库')
export const PARTNER_SERVICE_GLOBAL = new PartnerServiceItem('GLOBAL', 'GLOBAL', '集团公司')
export const PARTNER_SERVICE_SHIPPER = new PartnerServiceItem('SHIPPER', 'SHIPPER', '发货人')
export const PARTNER_SERVICE_CONSIGNEE = new PartnerServiceItem('CONSIGNEE', 'CONSIGNEE', '收货人')
export const PARTNER_SERVICE_NOTIFY = new PartnerServiceItem('NOTIFY', 'NOTIFY', '通知人')
export const PARTNER_SERVICE_PORT_AGENT = new PartnerServiceItem('PORT_AGENT', 'PORT_AGENT', '口岸代理')
export const PARTNER_SERVICE_FORWARDING_AGENT = new PartnerServiceItem('FORWARDING_AGENT', 'FORWARDING_AGENT', '发运代理')
export const PARTNER_SERVICE_LOADINGPLACE_COMPANY = new PartnerServiceItem('LOADINGPLACE_COMPANY', 'LOADINGPLACE_COMPANY', '装货地公司')
export const PARTNER_SERVICE_SIGNBILLPLACE_COMPANY = new PartnerServiceItem('SIGNBILLPLACE_COMPANY', 'SIGNBILLPLACE_COMPANY', '签单地公司')
export const PARTNER_SERVICE_DISCHARGEPORT_COMPANY = new PartnerServiceItem('DISCHARGEPORT_COMPANY', 'DISCHARGEPORT_COMPANY', '卸货港公司')
export const PARTNER_SERVICE_DESTINATIONPORT_COMPANY = new PartnerServiceItem('DESTINATIONPORT_COMPANY', 'DESTINATIONPORT_COMPANY', '目的港公司')
export const PARTNER_SERVICE_TERMINAL_COMPANY = new PartnerServiceItem('TERMINAL_COMPANY', 'TERMINAL_COMPANY', '码头公司')

export const PARTNER_COMPANY_TRADERS = new PartnerServiceItem('TRADERS_SIGN', 'COMPANY_TRADERS', '贸易商')
export const PARTNER_COMPANY_FACTORY_MANUFACTURER = new PartnerServiceItem('FACTORY_SIGN', 'COMPANY_FACTORY_MANUFACTURER', '工厂/生产商')

export const PARTNER_SERVICE_OTHER = new PartnerServiceItem('OTHER', 'OTHER', '其他')

export const PARTNER_COMPANY_VENDOR = new PartnerServiceItem('Vendor', 'Vendor', 'Vendor')
export const PARTNER_COMPANY_MIDDLEMAN = new PartnerServiceItem('Middleman', 'Middleman', '中间商')
export const PARTNER_COMPANY_FACTORY = new PartnerServiceItem('Factory', 'Factory', '工厂')
export const PARTNER_SERVICE_PARENT_COMPANY = new PartnerServiceItem('PARENT_COMPANY', 'PARENT_COMPANY', '母公司')

export const PARTNER_SERVICE_BOOKING_ALL = new PartnerServiceItem('BOOKING_ALL', 'ALL', '全部')// 订舱代理 船代
export const PARTNER_SERVICE_AGENT_ALL = new PartnerServiceItem('AGENT_ALL', 'ALL', '全部')// 目的港代理 指定货代理

export const PARTNER_LOB_1 = new PartnerServiceItem('SEA_EXPORT', 'Sea export', '海运出口')
export const PARTNER_LOB_2 = new PartnerServiceItem('SEA_IMPORT', 'Sea import', '海运进口')
export const PARTNER_LOB_3 = new PartnerServiceItem('AIR_EXPORT', 'Air export', '空运出口')
export const PARTNER_LOB_4 = new PartnerServiceItem('AIR_IMPORT', 'Air import', '空运进口')
export const PARTNER_LOB_5 = new PartnerServiceItem('RAILWAY_EXPORT', 'Railway Business', '铁路业务')
export const PARTNER_LOB_6 = new PartnerServiceItem('INTEGRATED_JOB', 'Integrated logistics', '综合物流')

export const PARTNER_LOB_ITEMS = [PARTNER_LOB_1, PARTNER_LOB_2, PARTNER_LOB_3, PARTNER_LOB_4, PARTNER_LOB_5, PARTNER_LOB_6]
/**
 * 数据集
 */
export const PARTNER_SERVICE_ITEMS = [PARTNER_SERVICE_ALL, PARTNER_SERVICE_CUSTOMER,
  PARTNER_SERVICE_BOOKING_AGENT, PARTNER_SERVICE_OVERSEA_AGENT, PARTNER_SERVICE_DESIGNATION_AGENT,
  PARTNER_SERVICE_LOCAL, PARTNER_SERVICE_SEA_CMP, PARTNER_SERVICE_AIR_CMP, PARTNER_SERVICE_CUSTOMS_BROKER,
  PARTNER_SERVICE_TRUCK_CMP, PARTNER_SERVICE_WAREHOUSE, PARTNER_SERVICE_GLOBAL, PARTNER_SERVICE_SHIPPER,
  PARTNER_SERVICE_CONSIGNEE, PARTNER_SERVICE_NOTIFY, PARTNER_SERVICE_PORT_AGENT, PARTNER_SERVICE_FORWARDING_AGENT,
  PARTNER_SERVICE_LOADINGPLACE_COMPANY, PARTNER_SERVICE_SIGNBILLPLACE_COMPANY, PARTNER_SERVICE_DISCHARGEPORT_COMPANY,
  PARTNER_SERVICE_DESTINATIONPORT_COMPANY, PARTNER_SERVICE_OTHER, PARTNER_SERVICE_SETTLEMENT_AGENT,
  PARTNER_COMPANY_TRADERS, PARTNER_COMPANY_FACTORY_MANUFACTURER, PARTNER_SERVICE_SEA_CMP_AGENT, PARTNER_SERVICE_TERMINAL_COMPANY]

export const PARTNER_SERVICE_ITEM_MAPPING = [
  { key: 'customer', value: PARTNER_SERVICE_CUSTOMER }, { key: 'bookingAgent', value: PARTNER_SERVICE_BOOKING_AGENT }, { key: 'overseaAgent', value: PARTNER_SERVICE_OVERSEA_AGENT },
  { key: 'designationAgent', value: PARTNER_SERVICE_DESIGNATION_AGENT }, { key: 'localAgent', value: PARTNER_SERVICE_LOCAL }, { key: 'seaCmp', value: PARTNER_SERVICE_SEA_CMP },
  { key: 'airCmp', value: PARTNER_SERVICE_AIR_CMP }, { key: 'customsBroker', value: PARTNER_SERVICE_CUSTOMS_BROKER }, { key: 'truckCmp', value: PARTNER_SERVICE_TRUCK_CMP },
  { key: 'warehouse', value: PARTNER_SERVICE_WAREHOUSE }, { key: 'global', value: PARTNER_SERVICE_GLOBAL }, { key: 'shipper', value: PARTNER_SERVICE_SHIPPER },
  { key: 'consignee', value: PARTNER_SERVICE_CONSIGNEE }, { key: 'notify', value: PARTNER_SERVICE_NOTIFY }, { key: 'portAgent', value: PARTNER_SERVICE_PORT_AGENT },
  { key: 'forwardingAgent', value: PARTNER_SERVICE_FORWARDING_AGENT }, { key: 'loadingPlaceCompany', value: PARTNER_SERVICE_LOADINGPLACE_COMPANY },
  { key: 'signBillPlaceCompany', value: PARTNER_SERVICE_SIGNBILLPLACE_COMPANY }, { key: 'dischargePortCompany', value: PARTNER_SERVICE_DISCHARGEPORT_COMPANY },
  { key: 'destinationPortCompany', value: PARTNER_SERVICE_DESTINATIONPORT_COMPANY }, { key: 'other', value: PARTNER_SERVICE_OTHER },
  { key: 'settlementAgent', value: PARTNER_SERVICE_SETTLEMENT_AGENT }, { key: 'tradersSign', value: PARTNER_COMPANY_TRADERS }, { key: 'factorySign', value: PARTNER_COMPANY_FACTORY_MANUFACTURER }
]

/**
 *  return null:没找到.
 */
export function getPartnerServiceItemByCode(code) {
  return Model.getObjByCode(code, PARTNER_SERVICE_ITEMS)
}
